
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/politica",
      function () {
        return require("private-next-pages/auth/politica.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/politica"])
      });
    }
  